// src/api/API.js
import axios from "axios";
import { clearAuth, isAuthApiError, redirectToLogin } from "../utils/auth";

const API = axios.create({
  baseURL: "/api",
});

// Request interceptor
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // JWT token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAuthApiError(error)) {
      clearAuth();
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default API;
